import type { FormTemplateField } from '@/types'

export const normalizeKeyword = (keyword: string) => keyword.trim().toLowerCase()

export const fieldMatchesKeyword = (field: FormTemplateField, keyword: string) => {
  if (!keyword) return true
  const normalized = normalizeKeyword(keyword)
  const base = `${field.label ?? ''} ${field.description ?? ''}`.toLowerCase()
  const optionText = (field.options || [])
    .map(option => `${option.label} ${option.value}`)
    .join(' ')
    .toLowerCase()
  return base.includes(normalized) || optionText.includes(normalized)
}

export const filterFieldsByKeyword = (
  fields: FormTemplateField[],
  sectionId: string | undefined,
  keyword: string,
) => {
  const normalized = normalizeKeyword(keyword)
  return fields
    .filter(field => (sectionId ? field.sectionId === sectionId : true))
    .filter(field => fieldMatchesKeyword(field, normalized))
}
